<template>
  <div id="app">
    <Wrapper />
  </div>
</template>

<script>
import Wrapper from "./components/pages/Wrapper";
export default {
  name: "App",
  components: {
    Wrapper
  }
};
</script>

<style>
@import url("https://fonts.googleapis.com/css?family=Roboto:300,400,500,700&display=swap");
.btn {
  text-transform: none;
  
}
</style>
